import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DealerApprovalPopupComponent } from "../../dbt/dealer/dealerapprovalpopup/dealerapprovalpopup.component";
import { ManufacturerService } from "src/app/services/manufacturer.service";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import * as moment from "moment";
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: "app-realtimetrackingpopup",
  templateUrl: "./realtimetrackingpopup.component.html",
  styleUrls: ["./realtimetrackingpopup.component.scss"]
})
export class RealtimetrackingpopupComponent implements OnInit {
  UnreachableReasonlist: any[] = [];
  form: FormGroup;
  today: Date;
  max: Date | any;

  constructor(
    public dialogRef: MatDialogRef<DealerApprovalPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private manufactureService: ManufacturerService,
    private alertService: AlertService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initializeValidators();
    this.get();
    this.today = new Date();
    this.max = new Date(moment(new Date()).add(1, 'days').format('YYYY, MM, DD'));
  }
  goToAction() {
    if (this.form.valid) {
      let data = {
        remarks: this.form.value.remarks,
        categoryType: this.dataRecievedToEdit.categoryType,
        vehicleStatusType: this.dataRecievedToEdit.vehicleStatusType,
        machineryUnreachableReasonType: this.form.value.machineryUnreachableReasonType,
        lastUpdatedTs: this.dataRecievedToEdit.lastUpdatedTs,
        vehicleId: this.dataRecievedToEdit.vehicleId,
        regNo: this.dataRecievedToEdit.regNo,
        divisionId: this.dataRecievedToEdit.divisionId,
        subDivisionId: this.dataRecievedToEdit.subDivisionId,
        regionId: this.dataRecievedToEdit.regionId,
        sinceWhenTs: moment(this.form.value.sinceWhenTs).format("YYYY-MM-DD"),
        driverName: this.dataRecievedToEdit.driverName
      };
      this.manufactureService
        .savemachineryUnreachableReasonType(data)
        .subscribe(result => {
          if (result) {
            this.alertService.success("Updated Successfully");
            this.dialogRef.close(true);
          }
        });
    } else {
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  pickerOpen(){
  //  this.startAt = new Date();
  //  this.maxDate = new Date();
 }

  initializeValidators() {
    this.form = this.formBuilder.group({
      machineryUnreachableReasonType: ["", Validators.required],
      sinceWhenTs: ["", Validators.required],
      remarks: ["", Validators.required]
    });
  }
  get() {
    this.UnreachableReasonlist = [];
    this.manufactureService
      .getmachineryUnreachableReasonType(true)
      .subscribe(res => {
        if (res) {
          this.UnreachableReasonlist = res;
        }
      });
  }
  changeClient2() {}
  next() {
    this.dialogRef.close(false);
  }
}
